<template>
  <BaseToast
    stripeColor="var(--color-red)"
    icon="fas fa-times"
    iconColor="var(--color-red)"
    :title="title || 'Error'"
    @close="$emit('close')"
  >
    <slot />
  </BaseToast>
</template>

<script setup lang="ts">
  import BaseToast from './BaseToast.vue';

  defineProps<{
    title?: string;
  }>();

  defineEmits<{
    close: [];
  }>();
</script>

<style scoped lang="scss">
  @use '@/app/assets/sass/variables' as *;

  :deep(.base-toast-icon) {
    background: var(--color-red-light);
  }

  :deep(.base-toast-icon .fas) {
    color: var(--color-red);
  }
</style>
